 import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function SplashScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user or merchant is already logged in
    const customerLogin = localStorage.getItem("isLoggedIn") === "true";
    const merchantLogin = localStorage.getItem("isLoggedIn") === "true";
console.log('here merchnat',merchantLogin)
console.log('here  customerLogin', customerLogin)
    const timer = setTimeout(() => {
      if (merchantLogin) {
        // Merchant direct dashboard par jayega
        navigate("/merchantrules", { replace: true });
      } else if (customerLogin) {
        // Customer direct dashboard par jayega
        navigate("/visit-dashboard", { replace: true });
      } else {
        // Login nahi hai toh Gateway screen par jayega
        navigate("/WelcomeGateway", { replace: true });
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

 
  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
        }

        .splash-screen {
          width: 100%;
          min-height: 100vh;
          min-height: 100dvh;

          display: flex;
          align-items: center;
          justify-content: center;

          background:
            radial-gradient(
              circle at center,
              #fff7ed 0%,
              #fff 42%,
              #f3f7ff 100%
            );

          overflow: hidden;
          position: relative;
          font-family: "Poppins", Arial, sans-serif;
        }

        /* Background circles */

        .splash-circle {
          position: absolute;
          border-radius: 50%;
          pointer-events: none;
        }

        .circle-one {
          width: 320px;
          height: 320px;
          top: -160px;
          right: -100px;
          background: rgba(255, 140, 66, 0.10);
          animation: floatOne 5s ease-in-out infinite;
        }

        .circle-two {
          width: 260px;
          height: 260px;
          bottom: -130px;
          left: -90px;
          background: rgba(255, 94, 98, 0.08);
          animation: floatTwo 5s ease-in-out infinite;
        }

        /* Main content */

        .splash-content {
          position: relative;
          z-index: 5;

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          text-align: center;

          animation: contentAppear 0.8s ease-out forwards;
        }

        /* Logo wrapper */

        .logo-wrapper {
          width: 150px;
          height: 150px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 38px;

          background: rgba(255, 255, 255, 0.95);

          box-shadow:
            0 25px 60px rgba(255, 107, 53, 0.18),
            0 8px 25px rgba(17, 24, 39, 0.08);

          animation:
            logoZoom 1.1s cubic-bezier(.2,.8,.2,1) forwards,
            logoFloat 3s ease-in-out 1.1s infinite;

          position: relative;
        }

        /* Orange glow */

        .logo-wrapper::before {
          content: "";
          position: absolute;

          width: 175px;
          height: 175px;

          border-radius: 44px;

          border: 2px solid rgba(255, 140, 66, 0.18);

          animation: pulseRing 1.8s ease-out infinite;
        }

        .logo-wrapper::after {
          content: "";
          position: absolute;

          width: 205px;
          height: 205px;

          border-radius: 50%;

          border: 1px solid rgba(255, 94, 98, 0.10);

          animation: pulseRing 2.2s ease-out 0.4s infinite;
        }

        .splash-logo {
          width: 205px;
          height: 205px;

          object-fit: contain;

          display: block;

          animation: logoImage 0.9s ease-out forwards;
        }

        /* Brand */

        .brand-name {
          margin-top: 32px;

          font-size: 30px;
          line-height: 1.2;

          font-weight: 800;

          color: #111827;

          letter-spacing: -0.8px;

          animation: textUp 0.8s ease-out 0.25s both;
        }

        .brand-name span {
          background:
            linear-gradient(
              135deg,
              #ff8c42,
              #ff5e62
            );

          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .brand-tagline {
          margin-top: 10px;

          font-size: 14px;

          color: #6b7280;

          font-weight: 500;

          animation: textUp 0.8s ease-out 0.4s both;
        }

        /* Loading dots */

        .loading-area {
          margin-top: 28px;

          display: flex;
          align-items: center;
          gap: 8px;

          animation: textUp 0.8s ease-out 0.55s both;
        }

        .loading-dot {
          width: 8px;
          height: 8px;

          border-radius: 50%;

          background: linear-gradient(
            135deg,
            #ff8c42,
            #ff5e62
          );

          animation: dotBounce 1.2s ease-in-out infinite;
        }

        .loading-dot:nth-child(2) {
          animation-delay: 0.15s;
        }

        .loading-dot:nth-child(3) {
          animation-delay: 0.3s;
        }

        /* Bottom text */

        .secure-text {
          position: absolute;

          bottom: 28px;

          left: 0;
          right: 0;

          text-align: center;

          color: #9ca3af;

          font-size: 12px;

          font-weight: 500;

          z-index: 5;

          animation: fadeIn 1s ease-out 0.8s both;
        }

        /* Animations */

        @keyframes contentAppear {
          from {
            opacity: 0;
            transform: translateY(20px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes logoZoom {
          0% {
            opacity: 0;
            transform: scale(0.45) rotate(-8deg);
          }

          60% {
            opacity: 1;
            transform: scale(1.08) rotate(2deg);
          }

          100% {
            opacity: 1;
            transform: scale(1) rotate(0deg);
          }
        }

        @keyframes logoImage {
          from {
            opacity: 0;
            transform: scale(0.7);
          }

          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes logoFloat {
          0%,
          100% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-8px);
          }
        }

        @keyframes pulseRing {
          0% {
            opacity: 0.7;
            transform: scale(0.8);
          }

          100% {
            opacity: 0;
            transform: scale(1.25);
          }
        }

        @keyframes textUp {
          from {
            opacity: 0;
            transform: translateY(15px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }

          to {
            opacity: 1;
          }
        }

        @keyframes dotBounce {
          0%,
          60%,
          100% {
            transform: translateY(0);
            opacity: 0.45;
          }

          30% {
            transform: translateY(-6px);
            opacity: 1;
          }
        }

        @keyframes floatOne {
          0%,
          100% {
            transform: translate(0, 0);
          }

          50% {
            transform: translate(-20px, 20px);
          }
        }

        @keyframes floatTwo {
          0%,
          100% {
            transform: translate(0, 0);
          }

          50% {
            transform: translate(20px, -20px);
          }
        }

        /* Mobile */

        @media (max-width: 600px) {

          .logo-wrapper {
            width: 125px;
            height: 125px;
            border-radius: 32px;
          }

          .logo-wrapper::before {
            width: 150px;
            height: 150px;
            border-radius: 38px;
          }

          .logo-wrapper::after {
            width: 175px;
            height: 175px;
          }

          .splash-logo {
            width: 288px;
            height: 288px;
          }

          .brand-name {
            margin-top: 28px;
            font-size: 25px;
          }

          .brand-tagline {
            font-size: 13px;
            padding: 0 25px;
          }

          .secure-text {
            bottom: 20px;
            font-size: 11px;
          }
        }

        @media (max-width: 380px) {

          .logo-wrapper {
            width: 110px;
            height: 110px;
          }

          .splash-logo {
            width: 278px;
            height: 278px;
          }

          .brand-name {
            font-size: 22px;
          }

          .brand-tagline {
            font-size: 12px;
          }
        }

        /* Large screens */

        @media (min-width: 1200px) {

          .logo-wrapper {
            width: 165px;
            height: 165px;
          }

          .splash-logo {
            width: 225px;
            height: 225px;
          }

          .brand-name {
            font-size: 34px;
          }
        }

        /* Accessibility */

        @media (prefers-reduced-motion: reduce) {

          .logo-wrapper,
          .splash-logo,
          .loading-dot,
          .brand-name,
          .brand-tagline,
          .loading-area,
          .secure-text {
            animation: none !important;
          }
        }
      `}</style>


      <div className="splash-screen">
        <div className="splash-circle circle-one"></div>
        <div className="splash-circle circle-two"></div>
        <div className="splash-content">
          <div className="logo-wrapper">
            <img
              src="/CvLogo.png"
              alt="Count My Visit"
              className="splash-logo"
            />
          </div>
          <h1 className="brand-name">
            Count <span>My Visit</span>
          </h1>
          <p className="brand-tagline">
            Smart Loyalty &amp; Customer Experience
          </p>
          <div className="loading-area">
            <span className="loading-dot"></span>
            <span className="loading-dot"></span>
            <span className="loading-dot"></span>
          </div>

        </div>

        <div className="secure-text">
          © Count My Visit • Smart Loyalty Platform
        </div>

      </div>
    </>
  );
}